import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import _ from 'lodash';
import { devConsoleLog } from '../../utils/utilityFunctions';
import { countries } from '../../Distributors/freedomDB/db';
import { getUserLocationApiUrl } from '../../utils/userConfig';

export const getUserLocation = createAsyncThunk('geoLocation/getUserLocation', async () => {
  const response = await axios.get(getUserLocationApiUrl());
let data={};
  let dataResponse = response?.data
  data.ip = dataResponse?.ip;
  data.country_code = dataResponse?.country.iso_code;
  data.latitude = dataResponse?.location?.latitude;
  data.longitude = dataResponse?.location?.longitude;
  data.region_name = dataResponse?.continent?.name;
  data.city_name = dataResponse?.city?.name;
  data.country_name = dataResponse?.country?.name;
  
  devConsoleLog('data of location actions', data);
  let country = '';
  let locationInfo = {
    CreatedByIp: '',
    CreatedByLatitude: '',
    CreatedByLongitude: '',
    CreatedByRegion: 'Asia',
    CreatedByCity: 'Lahore',
    CreatedByCountry: 'pakistan',
    CreatedByCountryCode: 'pk',
    CreatedByCountryId: 167
  };

  if (data) {
    if (Object.keys(data).length > 0) {
      country = countries.filter((country) => country.ISO2 === _.upperCase(data.country_code));
      // devConsoleLog("country", country)
      if (country.length > 0) {
        country = country[0].ID;
      } else {
        country = null;
      }
    } else {
      country = null;
    }

    locationInfo = {
      CreatedByIp: data.ip,
      CreatedByLatitude: data.latitude+'',
      CreatedByLongitude: data.longitude+'',
      CreatedByRegion: data?.region_name || data.region,
      CreatedByCity: data?.city_name || data.city,
      CreatedByCountry: data?.country_name || data.country,
      CreatedByCountryCode: data.country_code || data?.countryCode|| '',
      CreatedByCountryId: country
      // CreatedByIp: data.query,
      // CreatedByLatitude: data.lat,
      // CreatedByLongitude: data.lon,
      // CreatedByRegion: data.region,
      // CreatedByCity: data.city,
      // CreatedByCountry: data.country,
      // CreatedByCountryCode: data.countryCode,
      // CreatedByCountryId: country
    };
  }else{

  }

  devConsoleLog('locationInfo', locationInfo);
  // dispatch(updateLocation(locationInfo));
  return locationInfo;

  // return data;
});
